import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100vh;
  }
`;

export const ModalBaileys = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(250, 250, 250, 0.95);
  display: flex;
  justify-content: center;
  overflow-y: auto;
  z-index: 100;

  & > section {
    position: absolute;
    width: 100%;
    max-width: 800px;
    left: auto;
    top: auto;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    margin-top: 10%;
    padding-bottom: 30px;
    @media screen and (orientation: portrait) {
      margin-top: 0;
    }
  }
`;

export const BailetsBlock = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  padding-left: 0;
  padding-right: 0;
  box-sizing: border-box;

    > closeIcon_A {
      width: 43px;
      height: 44px;
    }

    & .closeIcon {
      position: fixed;
      right: 0;
      top: 168px;
      z-index: 1000;
      color: #000;
      cursor: pointer;
      left: 850px;
      margin-left: auto;
      margin-right: auto;
      @media screen and (orientation: portrait) {
        position: absolute;
        right: 11px;
        top: 11px;
        left: auto;
       }
    }

  & .mansion {
    margin-bottom: 40px;
  }

  & > h3 {
    color: #000;
    text-align: center;
    font-size: 25px;
    font-weight: 900;
    padding-bottom: 7px;
    @media screen and (orientation: portrait) {
      font-size: 22px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  & > .subTitle {
    width: 100%;
    padding-left: 40px;
    padding-right: 40px;
    box-sizing: border-box;
    margin-top: 40px;
    padding-bottom: 0;
    text-align: left;
    @media screen and (orientation: portrait) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  & > h2 {
    color: #000;
    text-align: center;
    font-size: 35px;
    font-weight: 900;
    margin-top: 5px;
    margin-bottom: 5px;
    text-transform: uppercase;
    @media screen and (orientation: portrait) {
      font-size: 20px;
      padding: 6px;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      margin: 0;
    }
  }

  & > h4 {
    width: 73%;
    text-align: left;
    margin-bottom: 12px;
    @media screen and (orientation: portrait) {
      width: 90%;
    }
  }

  & > .fullStory {
    position: relative;
    height: 40px;
    border-radius: 50px;
    border: 1px solid #DDD;
    background: rgb(255, 255, 255);
    color: rgb(0, 0, 0);
    text-align: center;
    font-family: Roboto;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.77px;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    padding-left: 30px;
    box-sizing: border-box;
    padding-right: 30px;
    margin-bottom: 30px;
    @media screen and (orientation: portrait) {
      margin-bottom: 20px;
      margin-top: 10px;
    }
  }

  & > div {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 40px;
    margin-bottom: 40px;
    & > a {
      position: absolute;
      width: 55px;
      height: 55px;
      & > svg {
        position: absolute;
        left: auto;
        top: auto;
        cursor: pointer;
        z-index: 1;
        @media screen and (orientation: portrait) {
          left: auto;
        }
      }
      @media screen and (orientation: portrait) {
        width: 55px;
      }
    }
    @media screen and (orientation: portrait) {
      margin-top: 30px;
    }
  }

  & video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  & img {
    width: 100%;
    height: auto;
    z-index: 1;
  }

  & p {
    color: #333;
    font-family: "Inconsolata", serif;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    line-height: 22px;
    letter-spacing: 1.56px;
    margin-top: 25px;
    padding-left: 40px;
    padding-right: 40px;
    box-sizing: border-box;
    @media screen and (orientation: portrait) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  & .topPargraph {
    width: 73%;
    padding: 0;
    @media screen and (orientation: portrait) {
      width: 90%;
    }
  }

  & > span {
    color: #000;
    text-align: center;
    font-size: 13px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  & > p {
    color: rgba(0, 0, 0, 0.70);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.52px;
  }
  & code {
    font-size: 12px;
    color: #2e95d3;
  }
  & .markTitle {
    width: 100%;
    text-align: left;
    font-size: 27px;
    color: #000;
    text-transform: none;
    letter-spacing: 0.5px;
    padding-left: 40px;
    padding-right: 40px;
    box-sizing: border-box;
    line-height: 25px;
    @media screen and (orientation: portrait) {
      font-size: 20px;
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  & .personaImg {
    width: 459px;
    height: auto;
    @media screen and (orientation: portrait) {
      width: 95%;
    }
  }

  & iframe {
    width: 100%;
    height: 100vh;
    border: 0;
    overflow-x: hidden;
    position: relative;
  }

  & .iframe_desktop {
    display: flex;
    margin-top: -92px;
    width: 119%;
    height: 4050px;
    @media screen and (orientation: portrait) {
      display: none;
    }
  }

  & .iframe_mobile {
    display: none;
    margin-top: -132px;
    @media screen and (orientation: portrait) {
      display: flex;
      height: 5350px;
    }
    @media (max-width: 375px) {
      height: 5750px;
    }
  }

  @media screen and (orientation: portrait) {
    padding: 30px;
    padding-left: 0;
    padding-right: 0;
    border: 0;
  }
`;

export const ModalFooter = styled.div`
  position: absolute;
  width: 100%;
  max-width: 900px;
  left: auto;
  bottom: 0;
  padding: 20px;
  padding-bottom: 30px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  justify-content: center;
`;

export const MenuWrap = styled.div`
  width: 100%;
  display: flex;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
`;
